import React from 'react';
import { UserRole } from '../types/commission';
import { Shield, User } from 'lucide-react';
import { motion } from 'framer-motion';
interface RoleSwitcherProps {
  currentRole: UserRole;
  onRoleChange: (role: UserRole) => void;
}
export function RoleSwitcher({
  currentRole,
  onRoleChange
}: RoleSwitcherProps) {
  return <div className="flex items-center bg-slate-100 p-1 rounded-lg border border-slate-200" data-id="element-122">
      <button onClick={() => onRoleChange('Loan Officer')} className={`relative flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md transition-colors z-10 ${currentRole === 'Loan Officer' ? 'text-blue-700' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-123">
        {currentRole === 'Loan Officer' && <motion.div layoutId="role-bg" className="absolute inset-0 bg-white shadow-sm rounded-md border border-slate-200/50 -z-10" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.6
      }} data-id="element-124" />}
        <User size={14} data-id="element-125" />
        <span data-id="element-126">Loan Officer</span>
      </button>

      <button onClick={() => onRoleChange('System Administrator')} className={`relative flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md transition-colors z-10 ${currentRole === 'System Administrator' ? 'text-blue-700' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-127">
        {currentRole === 'System Administrator' && <motion.div layoutId="role-bg" className="absolute inset-0 bg-white shadow-sm rounded-md border border-slate-200/50 -z-10" transition={{
        type: 'spring',
        bounce: 0.2,
        duration: 0.6
      }} data-id="element-128" />}
        <Shield size={14} data-id="element-129" />
        <span data-id="element-130">System Admin</span>
      </button>
    </div>;
}